import { z } from 'zod'

import type { Workspace } from 'features/workspace'
import type { WorkspaceGeneralConfigurationFragmentFragment as WorkspaceGeneralConfiguration } from 'gql/graphql'

export const schema = z.object({
  newDomainsDefaultBranch: z.string().min(1),
  workspaceId: z.string(),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({
  workspaceGeneralConfiguration: { newDomainsDefaultBranch },
  workspaceId,
}: {
  workspaceGeneralConfiguration: WorkspaceGeneralConfiguration
  workspaceId: Workspace['id']
}): Schema => ({
  newDomainsDefaultBranch,
  workspaceId,
})
